import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
    CADRAGE_AMOUNT_FIELD,
    Phase,
    PHASE_INSCRIPTION_NAME,
    STATUS_FIELD,
} from 'business/constants';
import { camelize } from 'helpers/syntaxHelper';
import { RQAPICallWithData } from 'store/APIClient';

/**
 * Middleware meant to be camelize pertinent values from phases settings endpoint
 */
export const getPhasesPostProcessingMiddleware = (body: {
    data: {
        phases: { [key: string]: string | boolean | number }[];
    };
}) => {
    const FIELDS_TO_CAMELIZE = [
        CADRAGE_AMOUNT_FIELD,
        PHASE_INSCRIPTION_NAME,
        STATUS_FIELD,
    ];

    const updatedPhases = body.data.phases.map((phase) =>
        Object.fromEntries(
            Object.entries(phase).map(([key, value]) => [
                key,
                FIELDS_TO_CAMELIZE.includes(key) && typeof value === 'string'
                    ? camelize(value)
                    : value,
            ]),
        ),
    );

    return {
        data: {
            phases: updatedPhases,
        },
    };
};

type PhasesResponse = {
    phases: Phase[];
};

/**
 * Hook to get the phases settings
 */
export const useGetPhases = (): UseQueryResult<Phase[]> =>
    useQuery<Phase[]>({
        queryKey: ['phases'],
        queryFn: async (): Promise<Phase[]> => {
            const response = await RQAPICallWithData<PhasesResponse>({
                endpoint: 'budget_proposals/phases_settings',
                method: 'GET',
                postProcessingCallback: getPhasesPostProcessingMiddleware,
            });
            return response.content.data.phases;
        },
    });
